export const RELEASE_TAGS: Record<number, 'internal' | 'alpha' | 'beta' | 'public' | undefined> = {
  0: undefined,
  1: 'internal',
  2: 'alpha',
  3: 'beta',
  4: 'public',
}
